import React, {useEffect, useRef, useState} from 'react';
import {_getStatusName, getExerciseIcon, getExerciseStatusStyle,} from "../../../utils/Movement";
import StartOrRetakeBtn from './StartOrRetakeBtn';
import RenderContent from './RenderBtn';
import ButtonComponent from './ButtonComponent';
import {Lightbox} from "react-modal-image";
import {Modal, ModalBody, ModalHeader} from "../../modal/Modal";
import {getExercises, getTotalCompleted} from './Services/MovementService';
import CONSTANT from '../../../constants/Constant';
import SelectedMovementBox from './SelectedMovementBox';
import {getBodyRegionNames} from '../../../utils/Utils';
import {canUserSkipExercise} from "./utilities/Utility";
import './LeftSidePanel.scss';
import GLOBAL from '../../../global';
import { useTenantFeatures } from '../../../features/tenantFeatures/useTenantFeature';


const LeftSidePanel = ({
                           exerciseList,
                           filteredExerciseList,
                           setFilteredExerciseList,
                           onClickRetakeExercise,
                           selectedExercise,
                           isShowSelectMovementBox,
                           toggleShowMovementBox,
                           childExerciseExerciseCodeNameList,
                           selectedRegions
                       }) => {

    const [annotationImageUrl, setAnnotationImageUrl] = useState('');
    const [measurementVideoUrl, setMeasurementVideoUrl] = useState('');
    const [totalCompleted, setTotalCompleted] = useState(0);
    const hideRetakeBtnOfExerciseIfChildExercise = useRef([]);

    useEffect(() => {
        async function fetchTotalCompleted() {
            let total = await getTotalCompleted(exerciseList, CONSTANT.EXERCISE_STATUS.COMPLETED.key,
                CONSTANT.EXERCISE_STATUS.RETAKE_HUMAN_EXPERT.key,
                CONSTANT.EXERCISE_STATUS.SKIPPED.key);
            setTotalCompleted(total);
        }

        fetchTotalCompleted().then(() => {
            let tempExercises = getExercises(exerciseList, ['calibration']);
            if (tempExercises.length > 0) {
                hideRetakeBtnOfExerciseIfChildExercise.current = tempExercises.flatMap(exercise => exercise?.MergeExercises || []);
            }
        });
    }, [exerciseList, filteredExerciseList]);

    useEffect(()=>{
        // console.log("dynamic testing of filtered excercise list.................................",filteredExerciseList)
    }, [filteredExerciseList]);

    const onClickViewMeasurementImage = (exercise) => {
        if (exercise && Object.keys(exercise).length > 0) {
            setAnnotationImageUrl(exercise['RenderImageUrl']);
        }
    };

    const onClickViewMeasurementVideo = (exercise) => {
        setMeasurementVideoUrl(exercise['RawVideoURL']);
    }

    const onClickCloseMeasurementImage = () => {
        setAnnotationImageUrl('');
    }

    const onClickVideoModalClose = () => {
        setMeasurementVideoUrl('');
    }

    const onChangeFilterExercises = (e) => {
        let filteredExercises = exerciseList.filter((exercise) => exercise.ExerciseDisplayName.toLowerCase().trim().match(e.target.value.toLowerCase()));

        if (filteredExercises) {
            setFilteredExerciseList(prev => filteredExercises.slice());
        }
    }

    const hideMovementBox = () => {
        toggleShowMovementBox(false);
    }

    const shouldBlurExerciseCard = () => {
        if (totalCompleted === exerciseList.length && exerciseList.length > 0) {
            return false;
        }
        return (!canUserSkipExercise(selectedExercise) || (isShowSelectMovementBox && selectedExercise?.ExerciseCodeName));
    }
    const { isExamineticsEnabled } = useTenantFeatures();


    return (
        <>
            <div>
                <div className="left-side-panel__searchbar">
                    <div className="left-side-panel__searchbar-icon">
                <span className="">
                    <i className="flaticon-search"/>
                </span>
                    </div>
                    <div className="left-side-panel__searchbar-vertical-line"></div>
                    <div className="left-side-panel__searchbar-input">
                        <input type="text" className="left-side-panel__searchbar-input" placeholder="Find a movement"
                               onChange={(e) => onChangeFilterExercises(e)}/>
                    </div>
                </div>
                {!isExamineticsEnabled && (
                <div className="left-side-panel__movement left-side-panel__body-region">
                    Body Region <span>:</span>{getBodyRegionNames(selectedRegions?.bodyRegionList)}
                </div>
                )}
                <div className="left-side-panel__completed-of">
                    {totalCompleted} completed of {exerciseList.length} movements
                </div>
            </div>
            <div className="left-side-panel--position-relative" style={{height: "59.5vh"}}>
                <div  className="left-side-panel--selected-movementbox-container left-side-panel--h-100-percent">
                    {isShowSelectMovementBox && selectedExercise?.ExerciseCodeName && (
                        <SelectedMovementBox
                            selectedExercise={selectedExercise}
                            hideMovementBox={hideMovementBox}
                            isAllCompleted={totalCompleted === exerciseList.length && exerciseList.length > 0}
                        />
                    )}

                    {filteredExerciseList
                        .filter(exercise => exercise.isDisplayInList)
                        .map((exercise,index) => {
                        return (
                            <>
                                <div
                                    className={`left-side-panel__exercise-row ${shouldBlurExerciseCard() ? "left-side-panel__exercise-row--blurred" : ""}`}>
                                    {/*<div className={`left-side-panel__exercise-content ${exercise.IsInMergeExercise ? "left-side-panel__exercise-content--child" : ""}`}>{console.log(childExerciseExerciseCodeNameList)}*/}
                                    <div
                                        className={`left-side-panel__exercise-content ${childExerciseExerciseCodeNameList.includes(exercise.ExerciseCodeName) ? "left-side-panel__exercise-content--child" : ""}`}>
                                        <div className='left-side-panel__exercise-info'>
                                        <span className="left-side-panel__exercise-icon">
                                                <img src={getExerciseIcon(exercise['Value'])} alt="movement icon"/>
                                            </span>
                                            <div>
                                                {/*<span>{exercise.Name}</span>*/}
                                                <span>{exercise.ExerciseDisplayName}</span>
                                                <div className="left-side-panel__exercise-status">
                                            <span
                                                className={`left-side-panel__status-text ${getExerciseStatusStyle(exercise.Status)}`}>
                                                <small>{_getStatusName(exercise.Status, exercise?.IsSkipExercise)}</small>
                                            </span>
                                                    {_getStatusName(exercise.Status, exercise?.IsSkipExercise) === CONSTANT.EXERCISE_STATUS.SKIPPED.key
                                                        ?
                                                        (
                                                            <span
                                                                className={`left-side-panel__status-text left-side-panel__status-text--spaced ${getExerciseStatusStyle(exercise.Status)}`}>
                                                                <small>Unable to Perform</small>
                                                            </span>
                                                        )
                                                        :
                                                        (
                                                            <>
                                                                {exercise['RenderImageUrl'] && (
                                                                    <RenderContent
                                                                        onClickViewContent={onClickViewMeasurementImage}
                                                                        exercise={exercise}
                                                                        text="Annotation"
                                                                        cssClass="fas fa-image"
                                                                    />
                                                                )}
                                                                {exercise['RawVideoURL'] && (
                                                                    <RenderContent
                                                                        onClickViewContent={onClickViewMeasurementVideo}
                                                                        exercise={exercise}
                                                                        text="Video"
                                                                        cssClass="fas fa-image"
                                                                    />
                                                                )}
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            {
                                                canUserSkipExercise(selectedExercise) &&
                                                !hideRetakeBtnOfExerciseIfChildExercise.current.includes(exercise?.ExerciseCodeName) &&

                                                (
                                                    <StartOrRetakeBtn
                                                        onClickStartOrRetakeExercise={() => onClickRetakeExercise(exercise, false, true)}
                                                        exercise={exercise}
                                                    />
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        );
                    })}
                    {annotationImageUrl !== '' && (
                        <Lightbox
                            // medium={annotationImageUrl}
                            large={annotationImageUrl}
                            hideZoom={true}
                            alt="Measurement"
                            hideDownload={true}
                            onClose={onClickCloseMeasurementImage}
                        />
                    )}
                    <Modal isOpen={measurementVideoUrl !== ''} className="modal-md">
                        <ModalHeader>
                            Exercise Video &nbsp;&nbsp;
                            <ButtonComponent
                                btnClass="left-side-panel__close-btn"
                                btnName="Close"
                                onClickHandler={onClickVideoModalClose}
                            />
                        </ModalHeader>
                        <ModalBody>
                            <div className={"video-wrapper"}>
                                <video autoPlay controls src={measurementVideoUrl}/>
                            </div>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
        </>
    );
}

export default LeftSidePanel;